import { render, staticRenderFns } from "./leverage-margin.vue?vue&type=template&id=1dea044c&scoped=true"
import script from "./leverage-margin.vue?vue&type=script&lang=js"
export * from "./leverage-margin.vue?vue&type=script&lang=js"
import style0 from "./leverage-margin.vue?vue&type=style&index=0&id=1dea044c&prod&scoped=true&lang=css"
import style1 from "./leverage-margin.vue?vue&type=style&index=1&id=1dea044c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dea044c",
  null
  
)

export default component.exports